import { message } from "antd";
import moment from "moment";
import { useIntl } from "react-intl";
import { isToday, isYesterday } from "date-fns";
export const dateFormatter = (
  DDMMYYYY,
  format = "DD/MM/YYYY hh:mm A"
) => {
  return moment(new Date(DDMMYYYY)).format(format);
};
//   export const dateTimezoneFormatter = (
//     DDMMYYYY,
//     format = "DD-MM-YYYY hh:mm A",
//     tz = "Asia/Kolkata"
//   ) => {
//     return momentTimezone.tz(moment(DDMMYYYY), tz).format(format);
//   };
export const dateTimeFormatter = (
  DDMMYYYY,
  format = {
    sameDay: "[Today] hh:mm A",
    lastDay: `[Yesterday] hh:mm A`,
    lastWeek: "DD/MM/YYYY hh:mm A",
    sameElse: "DD/MM/YYYY hh:mm A",
  }
) => {
  return moment(DDMMYYYY).calendar(null, format);
};
export const dateTimeFormatterForUTC = (
  DDMMYYYY,
  format = {
    sameDay: "[Today] hh:mm A",
    lastDay: "[Yesterday] hh:mm A",
    lastWeek: "DD/MM/YYYY hh:mm A",
    sameElse: "DD/MM/YYYY hh:mm A",
  }
) => {
  const istTime = moment.utc(DDMMYYYY).add(5, "hours").add(30, "minutes");
  return istTime.calendar(null, format);
};
export const useDateTimeFormatter = () => {
  const intl = useIntl();

  const dateTimeFormatter = (dateValue) => {
    const date = new Date(dateValue);

    if (isToday(date)) {
      return `${intl.formatMessage({ id: "today" })} ${intl.formatTime(date, {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    }

    if (isYesterday(date)) {
      return `${intl.formatMessage({ id: "yesterday" })} ${intl.formatTime(
        date,
        {
          hour: "2-digit",
          minute: "2-digit",
        }
      )}`;
    }

    return (
      intl.formatDate(date, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }) +
      " " +
      intl.formatTime(date, { hour: "2-digit", minute: "2-digit" })
    );
  };

  return dateTimeFormatter;
};
export const downloadURL = (uri, name) => {
  let link = document.createElement("a");
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const findCallNumberonMessage = (text) => {
  var urrled = /^[+]?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/im;
  var rx = /^[+-]?\d+$/;
  let regexTest = text.split(" ").filter((eve) => rx.test(eve) === true);
  text =
    regexTest.length && regexTest.length > 0
      ? regexTest.length > 1
        ? regexTest[0] + regexTest[1]
        : regexTest[0]
      : text;
  if (urrled.test(text)) {
    return text;
  } else {
    return undefined;
  }
};

export const findUrlOnMessage = (text) => {
  // var urlRegex =
  //   /(\b(https?|ftp|file:\/\/):[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w-]*)?(\?[^\s]*):[-A-Z0-9+&@#\u/%?=~_|!:,.;]*[-A-Z0-9+&@#\u/%=~_|])/gi;
  var urlRegex =
    /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w-]*)?(\?[^\s]*)?[-A-Z0-9+&@#\u/%?=~_|!:,.;]*[-A-Z0-9+&@#\u/%=~_|]?/gi;
  text = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  text = text.replace(/\r?\n/g, " <br/>");
  return text.replace(urlRegex, function (url) {
    let urlLink =
      url.includes("http://") || url.includes("https://")
        ? url
        : "https://" + url;
    return (
      '<a   target="_blank" rel="noopener noreferrer"  href="' +
      urlLink +
      '">' +
      url +
      "</a>"
    );
  });
};
export const urltoFile = (url, filename, mimeType) => {
  return fetch(url)
    .then((res) => {
      return res.arrayBuffer();
    })
    .then((buf) => {
      let blob = new Blob([buf], { type: mimeType });
      blob.name = filename;
      return blob;
    })
    .catch((err) => {
      console.error("urltoFile", err);
    });
};
export const downloadURLInOtherTab = (uri, name) => {
  let link = document.createElement("a");
  link.download = name;
  link.target = "_blank";
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
export const checkDeletedFunc = (arr = [], key, value) => {
  if (arr && Array.isArray(arr) && arr.length && key) {
    const dataFind = arr.find((fItem) => fItem[key] === value);
    if (dataFind && Object.keys(dataFind).length && dataFind[key]) {
      return dataFind[key];
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
};
export const getStringContentFeilds = (stringContents, rTemplateFeilds) => {
  let rstd = [];
  const mandatoryfield = rTemplateFeilds.slice(0, 2);
  rstd.push(...mandatoryfield);

  rTemplateFeilds.forEach((eve, index) => {
    if (
      (stringContents.includes(eve.field_label || eve.label) || eve.value) &&
      index > 1
    ) {
      rstd.push(eve);
    }
  });
  return rstd;
};
export const getStringContentforaddendumFeilds = (
  stringContents,
  rTemplateFeilds
) => {
  let rstd = [];

  rTemplateFeilds.forEach((eve, index) => {
    if (stringContents.includes(eve.field_label || eve.label)) {
      rstd.push(eve);
    }
  });
  return rstd;
};
export const formatArrayvalueToString = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return "";
  if (arr.length === 1) return arr[0];
  if (arr.length === 2) return `${arr[0]} and ${arr[1]}`;
  return `${arr.slice(0, -1).join(", ")}, and ${arr[arr.length - 1]}`;
};
export const checkFileTypeForPDF = (file) => {
  const fileNameParts = file?.name?.split(".") || [];
  const fileType = fileNameParts[fileNameParts.length - 1];

  if (fileNameParts.length > 1 && !["pdf"].includes(fileType.toLowerCase())) {
    message.error(`Only pdf is allowed!`);
    return false; // Prevent the file from being uploaded
  }

  return true; // Continue with the upload
};
export const checkAuthorization = (res) => {
  console.log("checkAuthorization", res);
  if (
    res?.STATUS_CODE === 401 &&
    res?.ERROR_CODE?.toLowerCase() === "unauthorized"
  ) {
    // message.error("You are not authorized to perform this action.");
    return true; // Not authorized
  }
  return false; // Authorized
};
export const fetchObligationInfo = async (link) => {
  try {
    console.log(link);
    const url = new URL(link);

    const token = url.searchParams.get("token");
    if (!token) throw new Error("Token missing");

    // call your backend API
    const res = await fetch(
      `/api/obligation/info?token=${encodeURIComponent(token)}`
    );
    if (!res.ok) {
      throw new Error("Failed to fetch obligation info");
    }

    const data = await res.json();
    return data; // { tokenData, obligation }
  } catch (err) {
    return { error: err.message };
  }
};

export const getContractExpiryInfo = (expiryDate) => {
  // Convert both dates to moment objects
  const today = moment().startOf("day"); // today's date (midnight)
  const expiry = moment(expiryDate).startOf("day"); // expiry date (midnight)

  // Difference in days
  const daysLeft = expiry.diff(today, "days");

  return {
    value: daysLeft,
    contractType: 3,
  };
};
